import DataTable from 'components/Display/DataTable/DataTable'
import {Page, PageContent} from 'components/Page'
import {
    useDeleteGuideMutation,
    useGetGuidesQuery,
} from 'store/slices/api/guidesApi'

const Guides = () => {
    return (
        <Page>
            <PageContent>
                <DataTable
                    allowEdit
                    allowDelete
                    confirmBeforeDelete
                    itemName="guide"
                    paginationType="external"
                    useGetQuery={useGetGuidesQuery}
                    useDeleteMutation={useDeleteGuideMutation}
                />
            </PageContent>
        </Page>
    )
}

export default Guides
